'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

function dynamic () {
  var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return void 0;
  };
  return /*#__PURE__*/React.lazy(cb);
}

module.exports = dynamic;
